import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Heading from '../../component/Heading/Headeing';

export const ModalBody = ({ children }) => (<div className="modal-body">{children}</div>);

export const ModalHeader = ({ children, onModalClose }) => (
	<div className="modal-header">
		<button display-if={onModalClose} type="button" className="close" aria-hidden="true"
						onClick={onModalClose}>&times;</button>
		<Heading size={4} className="modal-title">
			{children}
		</Heading>
	</div>
);

ModalHeader.propTypes = {
	onModalClose: PropTypes.func
};

export const ModalFooter = ({ children }) => (<div className="modal-footer">{children}</div>);

export class Modal extends Component {

	static SMALL = 'small';
	static LARGE = 'modal-lg-custom';
	static XL = 'modal-xl-custom';

	static defaultProps =  {
		isBackdropClose: false,
	};

	static propTypes = {
		isBackdropClose: PropTypes.bool,
		className: PropTypes.string,
		onModalClose: PropTypes.func,
		size: PropTypes.string,
	};

  static contextTypes = {
    registerPortalComponent: PropTypes.func.isRequired,
    unregisterPortalComponent: PropTypes.func.isRequired,
    mountIntoPortal: PropTypes.func.isRequired
  };

  get modal() {
    const { className, size } = this.props;
    return (
      <ReactCSSTransitionGroup component="div" className="modal-area"
                               style={{paddingRight: "10px", display: "block"}}
                               transitionName={{ appear:'fade',appearActive:'in'}}
                               transitionAppear={true}
                               transitionAppearTimeout={1000}
                               transitionEnter={false}
                               transitionLeave={false}
      >
        <div className="modal-backdrop"/>
        <div className="modal" style={{paddingRight: "10px", display: "block"}}
             onClick={this.modalBackdropHandler}>
          <div className={classNames(className, 'modal-dialog', size)} onClick={this.preventBackdropClick}>
            <div className="modal-content">
              {this.props.children}
            </div>
          </div>
        </div>
      </ReactCSSTransitionGroup>
    );
  }

  componentWillMount() {
	  this.context.registerPortalComponent(this);
  }

  componentDidMount() {
		this.renderModal();
	}

	componentDidUpdate() {
    this.renderModal();
  }

	componentWillUnmount() {
		this.context.unregisterPortalComponent(this);
	}

  render() { return null; }

	renderModal() {
    this.context.mountIntoPortal(this, this.modal);
  }

	modalBackdropHandler = () => {
		const { onModalClose, isBackdropClose } = this.props;

		if (isBackdropClose && onModalClose) {
			onModalClose();
		}
	}

	preventBackdropClick = (event) => {
		event.stopPropagation();
	}

}
